module.exports = __webpack_public_path__ + "static/media/loader.65fd4092.svg";